module.exports = __webpack_public_path__ + "static/media/efectividad.9ad68da1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/efectividad.jpg
// module id = 86
// module chunks = 0